import React from 'react';
import { Provider } from 'react-redux';
import UserflowTheme from '@lt/components/themes/userflow';

import ErrorBoundary from 'src/error/components/ErrorBoundary';
import { getStore } from './store';

import Header from '../../components/Header';

type Props = {
  store?: any;
  [k: string]: any;
};

const HeaderApp = ({ store, ...rest }: Props) => (
  <ErrorBoundary>
    <Provider store={store || getStore(rest)}>
      <UserflowTheme>
        <Header shouldFetchClientInfo />
      </UserflowTheme>
    </Provider>
  </ErrorBoundary>
);

export default HeaderApp;
